module.exports = __webpack_public_path__ + "img/big2-8.4a7c1ada.jpg";